import { Sidebar } from 'primereact/sidebar';
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

const SidebarCategoryForm = ({ show, close }) => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [isSignOut, setSignOut] = useState(false);

    const params = useParams();

    return (
        <Sidebar visible={show} onHide={close}>

            <h5 className="text-muted">Menu</h5>
            <ul className="list-group list-group-flush userMenu border-top">
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/document`} title="Dokumen Kendaraan" className="nav-link">
                        <span>Dokumen Kendaraan</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/elektrikal-dan-fitur`} title="Elektrikal dan Fitur" className="nav-link">
                        <span>Elektrikal dan Fitur</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/interior`} title="Interior" className="nav-link">
                        <span>Interior</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/mesin`} title="Mesin" className="nav-link">
                        <span>Mesin</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/fluida`} title="Fluida" className="nav-link">
                        <span>Fluida</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/air-conditioner`} title="Pendingin / AC" className="nav-link">
                        <span>Pendingin / AC</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/battery`} title="Battery / AKI" className="nav-link">
                        <span>Battery / AKI</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/exterior`} title="Exterior" className="nav-link">
                        <span>Exterior</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/rangka`} title="Frame / Rangka" className="nav-link">
                        <span>Frame / Rangka</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/suspensions`} title="Suspensi / Kaki-kaki" className="nav-link">
                        <span>Suspensi / Kaki-kaki</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/ban-rem-velg`} title="Ban, Rem, Velg" className="nav-link">
                        <span>Ban, Rem, Velg</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`/inspeksi/${params.item_id}/hasil-pemeriksaan`} title="Hasil Pemeriksaan" className="nav-link">
                        <span>Hasil Pemeriksaan</span>
                    </Link>
                </li>
            </ul>
        </Sidebar>
    );
}

export default SidebarCategoryForm;
